export const RouteConstant = {
    auth: {
        login: {
            path: "/login",
            name: "login",
        },
        signup: {
            path: "/signup",
            name: "signup",
        },
        otp: {
            path: "/otp",
            name: "otp",
        },
        invite: {
            path: "/invite",
            name: "invite",
        },
        protected: {
            path: "/protected",
            name: "protected",
        },
        error: {
            path: "/error",
            name: "error",
        },
        projects: {
            path: "/projects",
            name: "projects",
        },
        success: {
            path: "/success",
            name: "success",
        },
        successSignup: {
            path: "/success-signup",
            name: "sucess-signup",
        },
        successReset: {
            path: "/success-reset",
            name: "success-reset",
        },
        created: {
            path: "/created",
            name: "created",
        },
        changed: {
            path: "/changed",
            name: "changed",
        },
        reset: {
            path: "/reset",
            name: "reset",
        },
        resetPassword: {
            path: "/reset-password",
            name: "reset-Password",
        },
        changePassword: {
            path: "/change-password",
            name: "change-Password",
        },
    },
    dashboard: {
        dashboard: {
            path: "/dashboard",
            name: "dashboard",
        },
        billing: {
            path: "/billing",
            name: "billing",
        },
        account: {
            path: "/account",
            name: "account",
        },
        project: {
            path: "/project",
            name: "project",
        },
        applicationWorkspace: {
            path: "/applicationWorkspace",
            name: "applicationWorkspace",
        },
        entity: {
            path: "/entity",
            name: "entity",
        },
        attribute: {
            path: "/attribute",
            name: "attribute",
        },
        createWorkspace: {
            path: "/create-workspace",
            name: "Create Workspace",
        },
        workspace: {
            path: "/workspace",
            name: "Workspace",
        },
        inviteTeamMember: {
            path: "/invite-team-member",
            name: "Invite Team Member",
        }
    },
};
